var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button, Dimmer, Form, Loader, Message } from "semantic-ui-react";
import { postJsonWithAuthn } from "../RequestHelpers";
var CreateEstimateModal = /** @class */ (function (_super) {
    __extends(CreateEstimateModal, _super);
    function CreateEstimateModal(props) {
        var _this = _super.call(this, props) || this;
        _this.submit = function () {
            _this.setState({
                loading: true,
                success: false,
                error: false
            }, function () {
                postJsonWithAuthn("/admin/orders/id/" + encodeURIComponent(_this.props.orderId) + "/estimate", JSON.stringify({
                    msg: _this.state.msg,
                })).then(function (resp) {
                    if (resp.ok) {
                        _this.setState({
                            loading: false,
                            success: true
                        });
                    }
                    else {
                        _this.setState({
                            loading: false,
                            error: true
                        });
                    }
                }).catch(function (rej) {
                    console.error("Couldn't create estimate: " + rej);
                });
            });
        };
        _this.state = {
            loading: false,
            success: false,
            error: false,
            msg: ''
        };
        return _this;
    }
    CreateEstimateModal.prototype.render = function () {
        return React.createElement(Dimmer.Dimmable, { as: Form },
            React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                React.createElement(Loader, null)),
            this.state.success &&
                React.createElement(Message, { positive: true }, "Estimate created."),
            this.state.error &&
                React.createElement(Message, { negative: true }, "Estimate could not be created."),
            React.createElement(Button, { disabled: this.state.success, icon: 'dollar sign', label: 'Create estimate', labelPosition: 'left', onClick: this.submit, positive: true }));
    };
    return CreateEstimateModal;
}(React.PureComponent));
export default CreateEstimateModal;
//# sourceMappingURL=CreateEstimateModal.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/CreateEstimateModal.js
// module id = 1252
// module chunks = 0